import { memo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PropTypes from 'prop-types';

const BzToolTip = ({ placement = 'top', delay = { show: 0, hide: 400 }, ...props }) => {

    const BzTooltip = (renderprops) => {
        return (
            <Tooltip {...renderprops} data-testid="tooltip-msg">
                {props.TooltipMsg}
            </Tooltip>
        );
    };

    return (
        <OverlayTrigger {...props}
            placement={placement}
            delay={delay}
            overlay={BzTooltip}>
            {props.children}
        </OverlayTrigger>
    );
};

BzToolTip.propTypes = {
    placement: PropTypes.string,
    delay: PropTypes.exact({
        show: PropTypes.number,
        hide: PropTypes.number
    })
};


export default memo(BzToolTip);
